import { render } from "./NewLeadsForm.vue?vue&type=template&id=79e41174&scoped=true"
import script from "./NewLeadsForm.vue?vue&type=script&lang=js"
export * from "./NewLeadsForm.vue?vue&type=script&lang=js"

import "./NewLeadsForm.vue?vue&type=style&index=0&id=79e41174&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e41174"]])

export default __exports__